import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.bottom');
import { Input } from '@angular/core';

interface FileItem {
  name: string;
  status: '대기' | '완료';
  selected: boolean;
}

@Component({
    selector: 'wiz-component-bottom',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.bottom/view.scss */
/* src/app/component.bottom/view.scss: no such file or directory */`],
})
export class ComponentBottomComponent {
  @Input() completedFiles: FileItem[] = [];
}

export default ComponentBottomComponent;